





























import { Vue, Component } from 'vue-property-decorator'

const config = {
  name: 'icon-sign-language',
  components: {}
}

@Component(config)
export default class IconSignLanguage extends Vue {}
